import React, { Component } from 'react';

import DocumentSidebar from '../components/DocumentSidebar';
import SettingSidebar from '../components/SettingSidebar';
import ReportSidebar from '../components/ReportSidebar';
import DepartmentGroupsSettingSidebar from '../components/DepartmentGroupsSettingSidebar';
import Pathname from '../components/Pathname';

class Sidebar extends Component {
  render(){
    const prefixPathname = Pathname.prefixPathname(this.props.location);
    const { siteSetting } = this.props;
    var AppSidebar;

    switch(prefixPathname) {
      case 'documents':
        AppSidebar = <DocumentSidebar location={this.props.location} siteSetting={siteSetting}/>
        break;
      case 'settings':
        AppSidebar = <SettingSidebar location={this.props.location} siteSetting={siteSetting}/>
        break;
      case 'reports':
        AppSidebar = <ReportSidebar location={this.props.location} siteSetting={siteSetting}/>
        break;
      case 'manage_users':
        AppSidebar = <SettingSidebar location={this.props.location} siteSetting={siteSetting}/>
        break;
      case 'workflows':
        AppSidebar = <SettingSidebar location={this.props.location} siteSetting={siteSetting}/>
        break;
      case 'department_groups_settings':
        AppSidebar = <DepartmentGroupsSettingSidebar location={this.props.location} siteSetting={siteSetting}/>
        break;
      default:
        AppSidebar = <DocumentSidebar location={this.props.location} siteSetting={siteSetting}/>
    }

    return(
      <div className="d-none d-lg-inline">
        {AppSidebar}
      </div>
    )
  }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/layouts/Sidebar.js